import {
    ADD_COMMITMENT,
    GET_COMMITMENT,
    END_COMMITMENT_STREAM,
    GET_COMMITMENT_RECRUITEES
} from '../constants/commit.js';

export const initialState = {
    referrals: [],
    commitment: false,
    streamingRef: null
};

export function commitReducer( state = initialState, action ) {

    switch ( action.type ) {

        case ADD_COMMITMENT:
        case GET_COMMITMENT:

            return Object.assign( {}, state, {
                commitment: action.commitment,
                referrals: state.referrals
            });

        case GET_COMMITMENT_RECRUITEES:

            return Object.assign( {}, state, {
                referrals: action.referrals,
                streamingRef: action.streamingRef
            });

        case END_COMMITMENT_STREAM:

            let referrals = action.referrals;
            if ( typeof referrals === 'undefined' ) {
                referrals = state.referrals;
            }

            return Object.assign( {}, state, {
                streamingRef: null,
                referrals: referrals
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/commit.js